export default "__VITE_ASSET__B60Fn4Fb__"